module.exports = __webpack_public_path__ + "img/shopify.6edb721.png";